import gql from 'graphql-tag';

export const getShiftTypes = gql`
  query getShiftTypes {
    getShiftTypes {
      id
      name
      ShiftGroup {
        id
        name
      }
      sortOrder
    }
  }
`;
